import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface INearestStore {
  search?: string;
  store_input_groups_guid: IInputGroupsFilter[];
  order_by: string;
  in_person_possibility: boolean;
  has_guarantee: boolean;
  has_delivery: boolean;
  has_discount: boolean;
  app: string;
}

export interface ISerach {
  search: string;
}

export interface IInputGroupsFilter {
  guid: string;
  title: string;
}

const initialState: INearestStore = {
  search: '',
  store_input_groups_guid: [],
  order_by: '',
  in_person_possibility: false,
  has_guarantee: false,
  has_delivery: false,
  has_discount: false,
  app: 'supplier',
};

// TODO: Remove

export const nearestStoreSlice = createSlice({
  name: 'nearestStores',
  initialState,
  reducers: {
    findNearestStores: (state, action: PayloadAction<INearestStore>) => {
      state.store_input_groups_guid = action.payload.store_input_groups_guid;
      state.order_by = action.payload.order_by;
      state.in_person_possibility = action.payload.in_person_possibility;
      state.has_guarantee = action.payload.has_guarantee;
      state.has_delivery = action.payload.has_delivery;
      state.has_discount = action.payload.has_discount;
      state.app = action.payload.app;
    },
    findNearesStoresBySerach: (state, action: PayloadAction<ISerach>) => {
      state.search = action.payload.search;
    },

    resetNearestStores: (state, action: PayloadAction<INearestStore>) => {
      state.store_input_groups_guid = action.payload.store_input_groups_guid;
      state.order_by = action.payload.order_by;
      state.in_person_possibility = action.payload.in_person_possibility;
      state.has_guarantee = action.payload.has_guarantee;
      state.has_delivery = action.payload.has_delivery;
      state.has_discount = action.payload.has_discount;
      state.app = action.payload.app;
    },
  },
});
export const {findNearestStores, findNearesStoresBySerach, resetNearestStores} =
  nearestStoreSlice.actions;

export default nearestStoreSlice.reducer;
